
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/components/progression-bar",
      function () {
        return require("private-next-pages/design-system/components/progression-bar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/components/progression-bar"])
      });
    }
  